import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import IClientRepository from '../../2_domain/client/iClientRepository';
import Get from '../../lib/di/get';
import promiseResolver from '../../lib/util/promiseResolver';

const today = new Date(new Date().setHours(0, 0, 0, 0));
const todayPlusOne = new Date(new Date().setDate(today.getDate() + 1));

const usePatientBoardConttoller = (
  fromDate: Date | undefined,
  endDate: Date | undefined
) => {
  const patientRepo = Get.find<IClientRepository>('IClientRepository');

  const [newPatientCount, setNewPatientCount] = useState(0);
  const [totalPatientCount, setTotalPatientCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const navigateToPatientList = () => navigate('../patient/list');
  const navigetToAddPatient = () => navigate('../patient/add');

  const loadNewPatientCount = () => {
    promiseResolver({
      promise: patientRepo.getClients({
        searchText: '',
        pagination: {
          isAscending: false,
          pageNumber: 0,
          pageSize: 1,
        },
        fromDate: fromDate ?? today,
        endDate: endDate ?? todayPlusOne,
      }),
      successCallback: (data) => {
        setNewPatientCount(data.page?.totalElements ?? 0);
      },
      isLoadingCallback: setLoading,
    });
  };

  const loadTotalPatientCount = () => {
    promiseResolver({
      promise: patientRepo.getClients({
        searchText: '',
        pagination: {
          isAscending: false,
          pageNumber: 0,
          pageSize: 1,
        },
      }),
      successCallback: (data) => {
        setTotalPatientCount(data.page.totalElements);
      },
      isLoadingCallback: setLoading,
    });
  };

  useEffect(() => {
    loadNewPatientCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromDate, endDate]);

  useEffect(() => {
    loadTotalPatientCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromDate, endDate]);

  return {
    navigateToPatientList,
    navigetToAddPatient,
    newPatientCount,
    totalPatientCount,
    loading,
  };
};

export default usePatientBoardConttoller;
